var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_264:16819)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 3.03836C15.4113 3.29969 14.7787 3.47569 14.1147 3.55502C14.7927 3.14902 15.3133 2.50569 15.558 1.73902C14.924 2.11502 14.2213 2.38836 13.4733 2.53569C12.8753 1.89769 12.0213 1.49902 11.0773 1.49902C8.958 1.49902 7.40067 3.47636 7.87933 5.52902C5.152 5.39236 2.73333 4.08569 1.114 2.09969C0.254 3.57502 0.668 5.50502 2.12933 6.48236C1.592 6.46502 1.08533 6.31769 0.643333 6.07169C0.607333 7.59236 1.69733 9.01502 3.276 9.33169C2.814 9.45702 2.308 9.48636 1.79333 9.38769C2.21067 10.6917 3.42267 11.6404 4.86 11.667C3.48 12.749 1.74133 13.2324 0 13.027C1.45267 13.9584 3.17867 14.5017 5.032 14.5017C11.1267 14.5017 14.57 9.35436 14.362 4.73769C15.0033 4.27436 15.56 3.69636 16 3.03836Z",
    fill: "#030303"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_264:16819"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

export default SvgTwitter;